'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('CompanyChatHeadingConfig'), (0, _RecordPropType2.default)('OwnerChatHeadingConfig'), (0, _RecordPropType2.default)('UsersAndTeamsChatHeadingConfig')]);
module.exports = exports['default'];